/**
 * Check to see if the user is a mobile device
 * @returns True or false depending on the conditions checked to validate a mobile device
 */
export default function IsMobile() {
  //User Agent Detection
  const userAgent = navigator.userAgent || window.opera;
  const isUserAgentMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  //Screen Size Detection
  const isScreenSizeMobile = window.matchMedia('(max-width: 767px)').matches;

  //Touch Event Detection
  const isTouchDevice = 'ontouchstart' in document.documentElement && /Mobi/i.test(userAgent);

  //Combine all methods
  return isUserAgentMobile || isScreenSizeMobile || isTouchDevice;
}
